import React, { useRef, useState } from 'react';
import { createPortal } from 'react-dom';

/**
 * Infobulle riche au survol (DO-208) : l'attribut `title` natif ne sait pas mettre
 * en forme plusieurs lignes ni du texte long (notes). Positionnée en `fixed` depuis
 * le rectangle de l'élément survolé, et rendue dans un portail sur <body> : les
 * tableaux sont dans des conteneurs `overflow: auto` (qui rogneraient la bulle) et
 * une ligne peut avoir une opacité réduite (utilisateur bloqué) qu'elle hériterait.
 *
 * `content` : nœud React affiché dans la bulle. Le clic sur les enfants reste libre.
 */
export default function HoverCard({ content, children, delay = 250 }) {
  const [pos, setPos] = useState(null);
  const timer = useRef(null);

  const show = e => {
    const rect = e.currentTarget.getBoundingClientRect();
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      // Sous l'élément, ou au-dessus s'il est trop près du bas de l'écran
      const below = rect.bottom + 220 < window.innerHeight;
      setPos({
        left: Math.min(rect.left, window.innerWidth - 340),
        ...(below ? { top: rect.bottom + 6 } : { bottom: window.innerHeight - rect.top + 6 }),
      });
    }, delay);
  };

  const hide = () => {
    clearTimeout(timer.current);
    setPos(null);
  };

  return (
    <span style={styles.anchor} onMouseEnter={show} onMouseLeave={hide} onClick={hide}>
      {children}
      {pos && createPortal(<div role="tooltip" style={{ ...styles.card, ...pos }}>{content}</div>, document.body)}
    </span>
  );
}

const styles = {
  // inline-flex + middle : un inline-block s'aligne sur la ligne de base et décale
  // verticalement le contenu de la cellule par rapport au reste de la ligne
  anchor: { display: 'inline-flex', alignItems: 'center', verticalAlign: 'middle', maxWidth: '100%' },
  card: {
    position: 'fixed', zIndex: 60, width: 'max-content', maxWidth: '320px',
    background: '#ffffff', color: '#444444', border: '1px solid #cdcdcd', borderRadius: '8px',
    padding: '0.6rem 0.8rem', boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
    fontSize: '0.82rem', fontWeight: 400, lineHeight: 1.45, textAlign: 'left',
    whiteSpace: 'pre-wrap', wordBreak: 'break-word', pointerEvents: 'none',
  },
};
